(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.querySelectorAll('[data-quantity-input]').forEach((input) => {
    const max = parseInt(input.dataset.available);
    const min = parseInt(input.getAttribute('min')) || 1;
    const decrementBtn = input.closest('form')?.querySelector('[data-quantity-decrement]');

 
    input.addEventListener('input', () => {
      let value = parseInt(input.value);

      const mainquantitywrapper = input.closest('.pdp-main-product-qty');
      if ((value < 10) & mainquantitywrapper.classList.contains('quantity-added-grid')) {
        mainquantitywrapper.classList.remove('quantity-added-grid');
      }

      if (isNaN(value) || value < min) {
        input.value = min;
      } else if (value > max) {
        input.value = max;
      }
    });

    input.addEventListener('paste', (e) => {
      setTimeout(() => {
        let value = parseInt(input.value);
        if (isNaN(value) || value < min) {
          input.value = min;
        } else if (value > max) {
          input.value = max;
        }
      }, 0);
    });

 
    input.addEventListener('keydown', (e) => {
      if (['e', 'E', '+', '-'].includes(e.key)) {
        e.preventDefault();
      }
    });

    if (max > 1 && decrementBtn) {
      decrementBtn.classList.remove('disabled-minus');
      decrementBtn.classList.remove('hide-minus');
      decrementBtn.removeAttribute('tabindex');
      decrementBtn.removeAttribute('aria-disabled');
    }
  });


  document.addEventListener('DOMContentLoaded', function () {
    const quantityWrappers = document.querySelectorAll('[data-quantity-wrapper].pdp-main-product-qty');
    const errorMessage = document.getElementById('stock-error-message');
    const errorMessagePopup = document.getElementById('stock-error-message-popup');

    function clearError() {
      if (errorMessage) {
        errorMessage.textContent = '';
        errorMessage.style.display = 'none';
      }
      const errorMessagePopup = document.getElementById('stock-error-message-popup');
      if (errorMessagePopup) {
        errorMessagePopup.textContent = '';
        errorMessagePopup.style.display = 'none';
      }
    }

    function showError(text) {
      if (errorMessage) {
        errorMessage.textContent = text;
        errorMessage.style.display = '';
      }

      const errorMessagePopup = document.getElementById('stock-error-message-popup');
      if (errorMessagePopup) {
        errorMessagePopup.textContent = text;
        errorMessagePopup.style.display = '';
      }
    }

    function updateAllWrappers() {
      let errorShown = false;

      quantityWrappers.forEach((wrapper) => {
        const input = wrapper.querySelector('[data-quantity-input]');
        const plusButton = wrapper.querySelector('[data-quantity-increment]');
        if (!input || !plusButton) return;

       
        const available = parseInt(input?.dataset.available || '0', 10);
        const cartQuantityValue = parseInt(input?.dataset.cartQty || '0', 10);
        const availableStock = parseInt(input?.dataset.availablestock || '0', 10);
        const inventoryMgmt = !!input?.dataset.inventorymgmt?.trim();


        if (inventoryMgmt == false ){
          return;
        }

        // const available = parseInt(input.dataset.available || '0', 10);
        const productTitle = input.dataset.productTitle || 'this product';
        const current = parseInt(input.value || '0', 10);

      
        if (cartQuantityValue >= availableStock && availableStock != 0) {
          plusButton.disabled = true;
          plusButton.classList.add('disabled-minus');
          if (!errorShown) {
            showError(`The maximum quantity of this item is already in your basket.`);
            errorShown = true;
          }
          return;
        }

        const atMax = current >= available;
        plusButton.disabled = atMax;
        plusButton.classList.toggle('disabled-minus', atMax);

        if (atMax && !errorShown && availableStock != 0) {
          
          showError(`Only ${available} items will be added to your basket due to availability.`);

          errorShown = true;
        }
      });

      if (!errorShown) {
        clearError();
      }
    }

   
    updateAllWrappers();

   
    quantityWrappers.forEach((wrapper) => {
      const input = wrapper.querySelector('[data-quantity-input]');
      const plusButton = wrapper.querySelector('[data-quantity-increment]');
      const minusButton = wrapper.querySelector('[data-quantity-decrement]');

      if (!input || !plusButton) return;

    
      input.addEventListener('input', () => setTimeout(updateAllWrappers, 0));
    
      plusButton.addEventListener('click', () => setTimeout(updateAllWrappers, 0));
      if (minusButton) {
        minusButton.addEventListener('click', () => setTimeout(updateAllWrappers, 0));
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-custom-category-section"] && !Shopify.designMode) return;
  try {
    

  const subMenuExist = document.querySelector('[data-submenu]')
  if(subMenuExist && subMenuExist.dataset.submenu){
    document.body.classList.add('parent-category')
  }
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', () => {
      const applyAccordionState = () => {
        const showAccordionOnMobile =
          document.querySelector('[data-show-accordion]')?.getAttribute('data-show-accordion') === 'true';
        const isMobile = window.matchMedia('(max-width: 767px)').matches;
        document.querySelectorAll('details[data-accordion]').forEach((el) => {
          if (showAccordionOnMobile && isMobile) {
            // Show accordion on mobile if setting allows
            el.removeAttribute('open', '');
            document.querySelector('[data-show-accordion]').setAttribute('data-show-accordion','false');
          } else if (!showAccordionOnMobile && isMobile) {
            // Do not show accordion on mobile if setting disallows
           // el.setAttribute('open');
          } else if (!isMobile) {
            // On desktop, always open accordions
            el.setAttribute('open', '');
            document.querySelector('[data-show-accordion]').setAttribute('data-show-accordion','true');
          }
        });
      };
      applyAccordionState();
      window.addEventListener('resize', applyAccordionState);
      document.addEventListener('shopify:section:load', (event) => {
        // Apply accordion state when a new section is loaded
        applyAccordionState();
      });
    });
  
  } catch(e) { console.error(e); }
})();
})();
